
import { FaQuoteLeft } from "react-icons/fa";
import "swiper/css";
import 'swiper/css/autoplay';
import "swiper/css/pagination";
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";

function TestimonialCard({ data, title }) {
  return (
    <section className="social-proof-section-start-here py-5">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 social-proof-heading-div">
            {title && <h2 className="text-center mb-1">{title}</h2>}
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <Swiper
              grabCursor={true}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
                dynamicBullets: true,
              }}
              modules={[Autoplay, Pagination]}
              className="mySwiper"
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                992: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
            >
              {data.map((card) => (
                <SwiperSlide key={card.id}>
                  <div className="card border-0 h-100 p-3">
                    {/* Icon */}
                    <div className="mb-3 text-bg">
                      <FaQuoteLeft size={35} />
                    </div>

                    {/* Title */}
                    <h5 className="mb-3 fw-bold">{card.heading}</h5>

                    {/* Content */}
                    <p className="mb-4 text-muted flex-grow-1" style={{ fontStyle: "italic" }}>"{card.text}"</p>

                    {/* Name + College */}
                    <h6 className="mb-2 fw-semibold">{card.name}</h6>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TestimonialCard;

